import { render } from "./Lightbox-Contact.vue?vue&type=template&id=50b90bca"
import script from "./Lightbox-Contact.vue?vue&type=script&lang=js"
export * from "./Lightbox-Contact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__